const ro = {
  login_driver_title: "Intră în cursele tale",
  login_driver_sub: "Folosește numărul de telefon și PIN-ul primit de la birou.",
  phone: "Număr de telefon",
  phone_hint: "Cu prefixul țării, ex. +40 722 123 456",
  pin: "PIN",
  login: "Intră",
  logout: "Ieșire",
  driver: "Șofer",
  office: "Birou",
  my_orders: "Comenzile mele",
  active: "Active",
  completed: "Finalizate",
  no_orders: "Nu ai comenzi momentan.",
  refresh: "Reîmprospătează",
  loading: "Încărcare",
  unloading: "Descărcare",
  cargo: "Marfă",
  weight: "Greutate",
  ldm: "Metri liniari",
  pallets: "Paleți",
  vehicle: "Vehicul",
  notes: "Observații",
  office_notes: "Mesaj de la birou",
  navigate: "Navighează cu Google Maps",
  reference: "Referință",
  contact: "Contact",
  next_step: "Pasul următor",
  all_done: "Cursă finalizată. Mulțumim!",
  documents: "Poze CMR / Lieferschein",
  take_photo: "Fă poză",
  from_gallery: "Din galerie",
  cmr: "CMR",
  lieferschein: "Lieferschein",
  other: "Altul",
  issue: "Problemă",
  uploading: "Se încarcă...",
  uploaded: "Pozele au ajuns la birou",
  no_docs: "Încă nu ai trimis poze.",
  report_issue: "Raportează o problemă",
  issue_type: "Ce s-a întâmplat?",
  issue_delay: "Întârziere",
  issue_breakdown: "Defecțiune camion",
  issue_damage: "Marfă avariată",
  issue_refused: "Refuz la rampă",
  issue_other: "Altceva",
  note: "Detalii",
  note_ph: "Scrie pe scurt ce s-a întâmplat...",
  attach_photo: "Atașează poze",
  send: "Trimite",
  cancel: "Anulează",
  issue_sent: "Problema a fost trimisă la birou",
  issues: "Probleme raportate",
  resolved: "Rezolvat",
  open: "Deschis",
  progress: "Progres",
  history: "Istoric",
  location_saved: "Status salvat cu locația ta",
  location_off: "Status salvat (fără locație)",
  back: "Înapoi",
  date: "Data",
  stop: "Oprire",
  error: "Eroare. Încearcă din nou.",
  status_new: "Nouă",
  status_assigned: "Trimisă",
  status_received: "Comandă primită",
  status_arrived_loading: "La încărcare",
  status_loaded: "Încărcat",
  status_departed: "Pe drum",
  status_arrived_unloading: "La descărcare",
  status_unloaded: "Descărcat",
  step_received: "Am primit comanda",
  step_arrived_loading: "Am ajuns la încărcare",
  step_loaded: "Am încărcat",
  step_departed: "Am pornit",
  step_arrived_unloading: "Am ajuns la descărcare",
  step_unloaded: "Am descărcat",
  wa_title: "Comandă nouă - M-Line Solutions",
  wa_open: "Deschide comanda în aplicație (bifează statusurile și trimite pozele CMR):",
  wa_maps: "Navigare",
  install_hint: "Adaugă aplicația pe ecranul telefonului: meniul browserului → „Adaugă pe ecranul de pornire”.",
};

const en = {
  login_driver_title: "Open your trips",
  login_driver_sub: "Use your phone number and the PIN from the office.",
  phone: "Phone number",
  phone_hint: "With country code, e.g. +40 722 123 456",
  pin: "PIN",
  login: "Sign in",
  logout: "Sign out",
  driver: "Driver",
  office: "Office",
  my_orders: "My orders",
  active: "Active",
  completed: "Completed",
  no_orders: "You have no orders right now.",
  refresh: "Refresh",
  loading: "Loading",
  unloading: "Unloading",
  cargo: "Cargo",
  weight: "Weight",
  ldm: "Loading meters",
  pallets: "Pallets",
  vehicle: "Vehicle",
  notes: "Notes",
  office_notes: "Message from the office",
  navigate: "Navigate with Google Maps",
  reference: "Reference",
  contact: "Contact",
  next_step: "Next step",
  all_done: "Trip completed. Thank you!",
  documents: "CMR / Delivery note photos",
  take_photo: "Take photo",
  from_gallery: "From gallery",
  cmr: "CMR",
  lieferschein: "Delivery note",
  other: "Other",
  issue: "Issue",
  uploading: "Uploading...",
  uploaded: "Photos sent to the office",
  no_docs: "No photos sent yet.",
  report_issue: "Report a problem",
  issue_type: "What happened?",
  issue_delay: "Delay",
  issue_breakdown: "Truck breakdown",
  issue_damage: "Damaged cargo",
  issue_refused: "Refused at dock",
  issue_other: "Something else",
  note: "Details",
  note_ph: "Briefly describe what happened...",
  attach_photo: "Attach photos",
  send: "Send",
  cancel: "Cancel",
  issue_sent: "Problem sent to the office",
  issues: "Reported problems",
  resolved: "Resolved",
  open: "Open",
  progress: "Progress",
  history: "History",
  location_saved: "Status saved with your location",
  location_off: "Status saved (no location)",
  back: "Back",
  date: "Date",
  stop: "Stop",
  error: "Error. Please try again.",
  status_new: "New",
  status_assigned: "Sent",
  status_received: "Order received",
  status_arrived_loading: "At loading",
  status_loaded: "Loaded",
  status_departed: "On the road",
  status_arrived_unloading: "At unloading",
  status_unloaded: "Unloaded",
  step_received: "I received the order",
  step_arrived_loading: "Arrived at loading",
  step_loaded: "Loaded",
  step_departed: "Departed",
  step_arrived_unloading: "Arrived at unloading",
  step_unloaded: "Unloaded",
  wa_title: "New order - M-Line Solutions",
  wa_open: "Open the order in the app (tick the statuses and send the CMR photos):",
  wa_maps: "Navigation",
  install_hint: "Add the app to your home screen: browser menu → “Add to Home screen”.",
};

const de = {
  login_driver_title: "Zu deinen Fahrten",
  login_driver_sub: "Telefonnummer und PIN vom Büro verwenden.",
  phone: "Telefonnummer",
  phone_hint: "Mit Ländervorwahl, z. B. +49 151 1234567",
  pin: "PIN",
  login: "Anmelden",
  logout: "Abmelden",
  driver: "Fahrer",
  office: "Büro",
  my_orders: "Meine Aufträge",
  active: "Aktiv",
  completed: "Erledigt",
  no_orders: "Du hast derzeit keine Aufträge.",
  refresh: "Aktualisieren",
  loading: "Beladung",
  unloading: "Entladung",
  cargo: "Ware",
  weight: "Gewicht",
  ldm: "Lademeter",
  pallets: "Paletten",
  vehicle: "Fahrzeug",
  notes: "Hinweise",
  office_notes: "Nachricht vom Büro",
  navigate: "Mit Google Maps navigieren",
  reference: "Referenz",
  contact: "Kontakt",
  next_step: "Nächster Schritt",
  all_done: "Fahrt abgeschlossen. Danke!",
  documents: "Fotos CMR / Lieferschein",
  take_photo: "Foto machen",
  from_gallery: "Aus Galerie",
  cmr: "CMR",
  lieferschein: "Lieferschein",
  other: "Sonstiges",
  issue: "Problem",
  uploading: "Wird hochgeladen...",
  uploaded: "Fotos an das Büro gesendet",
  no_docs: "Noch keine Fotos gesendet.",
  report_issue: "Problem melden",
  issue_type: "Was ist passiert?",
  issue_delay: "Verspätung",
  issue_breakdown: "LKW-Panne",
  issue_damage: "Beschädigte Ware",
  issue_refused: "Abgelehnt an der Rampe",
  issue_other: "Etwas anderes",
  note: "Details",
  note_ph: "Kurz beschreiben, was passiert ist...",
  attach_photo: "Fotos anhängen",
  send: "Senden",
  cancel: "Abbrechen",
  issue_sent: "Problem an das Büro gesendet",
  issues: "Gemeldete Probleme",
  resolved: "Gelöst",
  open: "Offen",
  progress: "Fortschritt",
  history: "Verlauf",
  location_saved: "Status mit Standort gespeichert",
  location_off: "Status gespeichert (ohne Standort)",
  back: "Zurück",
  date: "Datum",
  stop: "Stopp",
  error: "Fehler. Bitte erneut versuchen.",
  status_new: "Neu",
  status_assigned: "Gesendet",
  status_received: "Auftrag erhalten",
  status_arrived_loading: "An der Beladestelle",
  status_loaded: "Beladen",
  status_departed: "Unterwegs",
  status_arrived_unloading: "An der Entladestelle",
  status_unloaded: "Entladen",
  step_received: "Auftrag erhalten",
  step_arrived_loading: "An Beladestelle angekommen",
  step_loaded: "Beladen",
  step_departed: "Losgefahren",
  step_arrived_unloading: "An Entladestelle angekommen",
  step_unloaded: "Entladen",
  wa_title: "Neuer Auftrag - M-Line Solutions",
  wa_open: "Auftrag in der App öffnen (Status abhaken und CMR-Fotos senden):",
  wa_maps: "Navigation",
  install_hint: "App zum Startbildschirm hinzufügen: Browser-Menü → „Zum Startbildschirm“.",
};

const dict = { ro, en, de };
export const LANGS = ["ro", "en", "de"];
export const t = (lang, key) => dict[lang]?.[key] ?? ro[key] ?? key;
